export default __webpack_public_path__ + "static/img_welfare_3@2x-3b1ed37a5e908dad1f524d03f9107254.jpg";